import { schedularAnnouncementActions } from './../../actions/constant';

const {
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  CREATE_ANNOUNCEMENT_RESET,
} = schedularAnnouncementActions;

const initialState: object = {
  response: null,
  loading: false,
};
export const createAnnouncementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CREATE_ANNOUNCEMENT_REQUEST: {
      return { ...state, loading: true };
    }

    case CREATE_ANNOUNCEMENT_SUCCESS: {
      return { ...state, response: action.payload, loading: false };
    }

    case CREATE_ANNOUNCEMENT_FAILURE: {
      return { ...state, response: action.payload, loading: false };
    }

    case CREATE_ANNOUNCEMENT_RESET:
      return initialState;

    default:
      return state;
  }
};
